// ── 통합 출퇴근 필터 창 안의 "회사" 칸 (2026-09-30 사용자 "DOT PINE 선택 버튼을 다른 위치로" → ① 필터 버튼 안으로) ──
//   예전엔 제목 아래 칩(CompanyFilterChips)이었다. 칩 모양·"한 회사는 늘 켜짐" 규칙은 그대로, 자리만 필터 창 맨 위로.
//   달력 탭(CalendarFilterPopover)·직원별 상세 탭(AttendanceFilterPopover)이 같이 쓴다. 선택은 두 탭이 한 벌(IntegratedAttendanceHub).
//   통합 연차·계약갱신은 칩을 그대로 쓴다(사용자 "출퇴근만").
import React from 'react';
import CompanyFilterChips from '../integrated/CompanyFilterChips';

/** companyFilter = { companyCodes, selected, onChange } | null(통합 메뉴가 아님 → 칸 없음) */
export function companyFilterUsable(cf) {
  return Boolean(cf && Array.isArray(cf.companyCodes) && cf.companyCodes.length > 0 && typeof cf.onChange === 'function');
}

function selectedOf(cf) {
  return Array.isArray(cf.selected) ? cf.selected : cf.companyCodes;
}

/** 일부 회사만 골랐으면 필터 1개로 센다(버튼 숫자·X 초기화) — 전부 켜짐이 기본값 */
export function companyFilterActive(cf) {
  if (!companyFilterUsable(cf)) return false;
  return selectedOf(cf).length < cf.companyCodes.length;
}

/** X(초기화) — 회사도 전부 켜짐으로 */
export function resetCompanyFilter(cf) {
  if (companyFilterUsable(cf)) cf.onChange([...cf.companyCodes]);
}

export function CompanyFilterField({ companyFilter: cf }) {
  if (!companyFilterUsable(cf)) return null;
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
      <span style={{ fontSize: 12, fontWeight: 700, color: 'var(--text-muted)', minWidth: 28 }}>회사</span>
      <CompanyFilterChips companyCodes={cf.companyCodes} selected={selectedOf(cf)} onChange={cf.onChange} />
    </div>
  );
}
